import React from 'react';
import { Outlet } from 'react-router-dom';

import { MarketBasketDetailsProvider } from './market-basket-details.provider';

export const MarketBasketDetailsDependencies = () =>
  <MarketBasketDetailsProvider>
    <Outlet/>
  </MarketBasketDetailsProvider>;
